import { getStoryList } from '../../../utils/neurons';

export default async function getStories(query, { alias }) {
    const response = await getStoryList({
        queryKey: [null, {
            storyType: alias,
            project: 'media.vkplay.ru',
            search: query,
        }],
    });

    const results = response.results.map((story) => ({
        value: story.id,
        label: story.title,
    }));

    return results;
}
